import * as React from "react";
import styled from "styled-components";
import { borderRadiusM, colorFunctionalWhite, fontSizeM, spacingM, spacingMl } from "@rhumbix/rmbx_design_system_design_tokens";
/**
 * @prop {string} title The title text to display at the top of the card
 * @prop {any} children The contents of the card
 */
const Card = ({ title, children }) => (React.createElement(StyledCard, null,
    React.createElement(StyledTitle, null, title),
    children));
const StyledTitle = styled.div `
    font-size: ${fontSizeM};
    font-weight: 700;
`;
// TODO: Talk with KB and find a color in our library that best matches the box shadow
const StyledCard = styled.div `
    background: ${colorFunctionalWhite};
    margin: ${spacingM};
    padding: ${spacingMl};
    height: auto;
    width: auto;
    box-shadow: 0px 2px 4px rgba(22, 22, 22, 0.25); 
    border-radius: ${borderRadiusM};
`;
export default Card;
